import { makeStyles, StepLabel } from '@material-ui/core';

export const Label = (props: CustomStepperLabelProps) => {
  const {
    activeStep,
    description,
    expandAll,
    label,
    onStepChange,
    orientation,
    stepIcon,
    stepIndex,
  } = props;
  const classes = useStyles(orientation)();

  return (
    <StepLabel
      classes={{
        root: classes.label,
        iconContainer: classes.icon,
        labelContainer: classes.container,
      }}
      StepIconComponent={stepIcon}
      onClick={() => onStepChange(stepIndex)}
    >
      {label}
      {orientation === 'vertical' && (stepIndex === activeStep || expandAll) ? (
        <span className={classes.description}>{description}</span>
      ) : null}
    </StepLabel>
  );
};
const useStyles = (orientation: 'vertical' | 'horizontal') =>
  makeStyles((theme) => ({
    container: {
      width: 'unset',
    },
    description: {
      opacity: 0.7,
      fontSize: 12,
      marginLeft: theme.spacing(2),
    },
    icon: {
      paddingRight: orientation === 'vertical' ? theme.spacing(1) : 0,
      paddingBottom: orientation === 'horizontal' ? theme.spacing(1) : 0,
    },
    label: {
      flexDirection: orientation === 'vertical' ? 'row' : 'column',
      alignItems: 'center',
      justifyContent: orientation === 'horizontal' ? 'center' : 'unset',
      cursor: 'pointer !important',
    },
  }));
